import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import "../../../styles/BoatList.scss";
import "./Reschedule.scss";
import { Link } from "react-router-dom";
import { Skeleton } from "antd";
import NavBar from "../../common/forms/NavbarCopy";
import { Form } from "informed";
import { TextInput, DropDown, FileUploader, NumberInput, TextArea } from "../../forms/index";
import { Row, Col, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import { subDirectory } from "../../../config.json";
import { GetRescheduleCharges, getGstData, getRescheduleBoat, getAvailableBoatSlotTime, rescheduleBeforeTransaction, CheckWDAndWEBoatCharge, getBookedOtherService } from "../../../services/RescheduleService";
import { getDefaultPaymentType} from "../../../services/boatListService";

import { AddNotification } from "../../../components/Methods/Notificaition";
import { getLocalStorageValues, removeCookieData, storeCookieData } from "../../../services/boat";

import { SkRescheduleDetailsCard } from "../../common/skeleton/subcatCardSkeleton";
import { Loader } from "../../common/forms/Loading/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { AutocompleteValue } from "../../common/forms/Autocomplete";
import { format } from "date-fns";
import { BsArrowLeft } from "react-icons/bs";
import { push } from "joi-browser";
import paymentGatwayURI from "../../../config.json";
import CryptoJS from 'crypto-js';

class RescheduleInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentdate: moment(new Date()).format("DD-MM-YYYY"),
      Rescheduleinfo: {},
      RescheduleCharges: {},
      AvailableRescheduleBoat: [],
      AvailableOtherService: [],
      OtherServiceDate: {},
      AvailableOtherServiceDate: {},
      GSTDetails: {},
      selectedTime: {},
      selectedDate: {},
      AvailableTimeSlot: {},
      RescheduleAmount: 0,
      RescheduleGST: 0,
      RescheduleNetAmount: 0,
      isReschedulingLoading: false,
      // isReschedulingAvailable: false,
    };
  }

  encryptedValuesFun (value)  {
	  const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString();
	 
    if (encryptedValue) {
      return encryptedValue.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe encoding
    }
	}
  componentDidMount = async () => {
    console.log(this.props);
    await this.setState({ isReschedulingLoading: true });
    if (this.props.location?.state?.RescheduleInfo?.BookingId) {
      console.log(this.props.location.state.RescheduleInfo);
      let Rescheduleinfo = this.props.location.state.RescheduleInfo;
      await this.setState({ Rescheduleinfo: Rescheduleinfo });

      await this.GetRescheduleCharges(Rescheduleinfo.BookingId, Rescheduleinfo.BoatHouseId);
      await this.getRescheduleBookedBoat(Rescheduleinfo.BookingId, Rescheduleinfo.BoatHouseId);
      await this.getBookedOtherServiceDetails(Rescheduleinfo.BookingId, Rescheduleinfo.BoatHouseId);
      await this.getGst();
    } else {
      alert("No Booking Found");
      this.props.history.goBack();
    }
    await this.setState({ isReschedulingLoading: false });
  };

  setFormApi = (formApi) => {
    this.formApi = formApi;
  };

  GetRescheduleCharges = async (BookingId, BoatHouseId) => {
    let data = {
      // QueryType: "GetRescheduleCharges",
      QueryType: "PublicGetRescheduleCharges",
      BookingId: BookingId,
      BoatHouseId: BoatHouseId,
      FromDate: this.state.currentdate,
      ToDate: this.state.currentdate,
      UserId: getLocalStorageValues("UserId"),
      MobileNo: getLocalStorageValues("MobileNo"),
      RescheduleType: "CR",
      stgBookingPin: "",
      RescheduleOldDate: "",
      RescheduleNewDate: "",
    };

    let res = await GetRescheduleCharges(data);
    console.log(res);

    if (res.data.Table.length > 0) {
      let RescheduleCharges = res.data.Table[0];
      this.setState({ RescheduleCharges: RescheduleCharges });
    } else {
      console.log("no data found for reschdule");
      this.setState({ RescheduleCharges: [] });
    }
    // await this.setState({ loading: false });
  };

  getGst = async () => {
    let data = {
      ServiceId: "1",
      ValidDate: moment(new Date(), "dd/MM/yyyy"),
    };

    const res = await getGstData(data);

    if (res.data?.StatusCode && res.data?.Response?.[0]) {
      let gstname = res.data.Response[0].TaxName;
      let gstsplit = gstname.split(",");

      let cgstarry = gstsplit[0].split("-");
      let sgstarry = gstsplit[1].split("-");
      let CGST = cgstarry[1];
      let SGST = sgstarry[1];
      let gstPercentage = 0;
      gstname.split(",").map((gst) => {
        let index = gst.indexOf("-");
        let percent = gst.substr(index + 1);
        gstPercentage += parseFloat(percent);
      });
      let GSTDetails = {
        SGST: SGST,
        CGST: CGST,
        TotalGSTPercentage: gstPercentage,
        GSTName: gstname,
      };
      console.log("GSTINFO", { GSTDetails });
      await this.setState({ GSTDetails: GSTDetails });
    } else {
      await this.setState({ GSTDetails: {} });
    }
  };
  getRescheduleBookedBoat = async (BookingId, BoatHouseId) => {
    let data = {
      // QueryType: "SingleBookingDetails",

      QueryType: "PublicSingleBookingDetails",

      BookingId: BookingId,
      BoatHouseId: BoatHouseId,
      FromDate: this.state.currentdate,
      ToDate: this.state.currentdate,
      UserId: getLocalStorageValues("UserId"),
      MobileNo: getLocalStorageValues("MobileNo"),
      RescheduleType: "CR",
      stgBookingPin: "",
      RescheduleOldDate: "",
      RescheduleNewDate: "",
    };
    const res = await getRescheduleBoat(data);
    if (res.data?.Table?.length > 0) {
      let ORSAvailableDate = {};
      let ORSDate = res.data?.Table?.map((boat) => {
        if (boat.Alert.includes("Success")) {
          return (ORSAvailableDate[boat.BoatReferenceNo] = { ROSOldDate: boat.RescheduledDate, ROSNewDate: "", BoatReferenceNo: boat.BoatReferenceNo });
        }
      });
      await this.setState({ AvailableRescheduleBoat: res.data.Table, OtherServiceDate: ORSAvailableDate });
      await this.onGetOtherServicesDate();
    } else {
      console.log("no booked boat data found for reschdule");
      this.setState({ AvailableRescheduleBoat: [] });
    }
  };
  getBookedOtherServiceDetails = async (BookingId, BoatHouseId) => {
    let data = {
      // QueryType: "SingleBookingDetails",
      QueryType: "PublicOtherService",
      BookingId: BookingId,
      BoatHouseId: BoatHouseId,
      FromDate: this.state.currentdate,
      ToDate: this.state.currentdate,
      UserId: getLocalStorageValues("UserId"),
      MobileNo: getLocalStorageValues("MobileNo"),
      RescheduleType: "",
      stgBookingPin: "",
      RescheduleOldDate: "",
      RescheduleNewDate: "",
    };

    const res = await getBookedOtherService(data);
    if (res.data?.Table?.length > 0) {
      await this.setState({ AvailableOtherService: res.data.Table });
    } else {
      console.log("no booked otherservices data found for reschdule");
      this.setState({ AvailableOtherService: [] });
    }
  };

  handleBoatTimeChange = async (e, boat) => {
    console.log(e.target.value, boat);
    let selectedTime = this.state.selectedTime;
    let selectedDate = this.state.selectedDate[boat.BoatReferenceNo];
    let OtherServiceDate = this.state.OtherServiceDate;
    if (e.target.value) {
      selectedTime[`${boat.BoatReferenceNo}`] = { slotId: e.target.value, slotDate: selectedDate, boat: boat };
      OtherServiceDate[boat.BoatReferenceNo] = { ROSOldDate: boat.RescheduledDate, ROSNewDate: selectedDate, BoatReferenceNo: boat.BoatReferenceNo };
    } else {
      selectedTime[`${boat.BoatReferenceNo}`] = {};
      OtherServiceDate[boat.BoatReferenceNo] = { ROSOldDate: boat.RescheduledDate, ROSNewDate: "", BoatReferenceNo: boat.BoatReferenceNo };
    }
    await this.setState({ selectedTime: selectedTime, OtherServiceDate: OtherServiceDate });
    await this.onGetOtherServicesDate();
    // this.forceUpdate();
    await this.amountCalculation();
  };
  onGetOtherServicesDate = async () => {
    this.formApi.setValue("BRSOtherServiceDate", "");
    let OtherServiceDate = this.state.OtherServiceDate;
    let AvailableOtherServiceDate = {};
    Object.values(OtherServiceDate).map((service) => {
      if (service.ROSNewDate) {
        let ROSNewDate = format(service.ROSNewDate, "dd-MM-yyyy");
        AvailableOtherServiceDate[ROSNewDate] = { ROSDate: ROSNewDate };
      } else {
        AvailableOtherServiceDate[service.ROSOldDate] = { ROSDate: service.ROSOldDate };
      }
    });

    await this.setState({ AvailableOtherServiceDate: AvailableOtherServiceDate });
  };
  handleOtherServiceDateChange = (e) => {
    let BRSOtherServiceDate = this.formApi.getValue("BRSOtherServiceDate");
    console.log(e.target.value, "ROS Date", BRSOtherServiceDate);
  };
  CheckWeekDays = async (date, boat) => {
    let data = {
      QueryType: "PublicCheckWDAndWEBoatCharge",
      BookingId: boat.BookingId,
      BoatHouseId: this.state.Rescheduleinfo?.BoatHouseId,
      FromDate: "",
      ToDate: "",
      UserId: "0",
      MobileNo: "0",
      RescheduleType: "",
      stgBookingPin: boat.BookingPin,
      RescheduleOldDate: boat.RescheduledDate,
      RescheduleNewDate: format(new Date(date), "yyyy-MM-dd"),
    };
    const res = await CheckWDAndWEBoatCharge(data);
    console.log(res, data);
    if (res.data?.Table?.length > 0) {
      let status = res.data.Table[0]?.Alert;
      if (status?.includes("Success")) {
        return true;
      } else {
        await this.setState({
          loading: false,
          variant: "info",
          openNotification: true,
          message: status.replace("Failure ~ ", ""),
        });
        return false;
      }
    } else {
      await this.setState({
        variant: "info",
        openNotification: true,
        message: "Please Select Different Reschedule Date",
      });
      return false;
    }
  };
  handleBoatDateChange = async (date, boat) => {
    this.formApi.setValue(`boatTime${boat.BoatReferenceNo}`, "");
    let AvailableTimeSlot = this.state.AvailableTimeSlot;
    let selectedDate = this.state.selectedDate;
    let selectedTime = this.state.selectedTime;
    let OtherServiceDate = this.state.OtherServiceDate;
    let checkDay = false;
    selectedTime[`${boat.BoatReferenceNo}`] = {};
    OtherServiceDate[boat.BoatReferenceNo] = { ROSOldDate: boat.RescheduledDate, ROSNewDate: "", BoatReferenceNo: boat.BoatReferenceNo };

    console.log(date, boat);
    selectedDate[`${boat.BoatReferenceNo}`] = date;
    await this.setState({ selectedDate: selectedDate });
    if (this.state.RescheduleCharges.ChargeType == "P") {
      //to check reschdule date and booked date is week day or not
      checkDay = await this.CheckWeekDays(date, boat);
    } else {
      checkDay = true;
    }

    if (checkDay) {
      let data = {
        BoatHouseId: this.state.Rescheduleinfo.BoatHouseId,
        CheckInDate: format(new Date(date), "dd/MM/yyyy"),
        BoatTypeId: boat.BoatTypeId,
        BoatSeaterId: boat.BoatSeaterId,
        SlotType: boat.PremiumStatus,
      };
      console.log(data);

      const res = await getAvailableBoatSlotTime(data);
      console.log(res);

      if (res.data.StatusCode && res.data.Response.length > 1) {
        AvailableTimeSlot[boat.BoatReferenceNo] = res.data.Response;
        // await this.setState({ AvailableTimeSlot: AvailableTimeSlot });
      } else {
        AvailableTimeSlot[boat.BoatReferenceNo] = [];
        // await this.setState({ AvailableTimeSlot: AvailableTimeSlot });
      }
    } else {
      AvailableTimeSlot[boat.BoatReferenceNo] = [];
      // await this.setState({ AvailableTimeSlot: AvailableTimeSlot });
    }
    await this.setState({ AvailableTimeSlot: AvailableTimeSlot, selectedTime: selectedTime, OtherServiceDate: OtherServiceDate });
    await this.onGetOtherServicesDate();
    await this.amountCalculation();
  };
  amountCalculation = async () => {
    const { SGST, CGST, TotalGSTPercentage } = this.state.GSTDetails;
    const { Charges, ChargeType } = this.state.RescheduleCharges;
    let selectedTime = this.state.selectedTime;
    let RescheduleAmount = 0;
    let RescheduleGST = 0;
    let RescheduleNetAmount = 0;
    Object.values(selectedTime).map((rboat) => {
      if (rboat.slotId && rboat.slotDate && rboat.boat) {
        if (ChargeType == "F") {
          RescheduleAmount = parseFloat(RescheduleAmount) + parseFloat(Charges);
        } else if (ChargeType == "P") {
          let boatRescheduleAmount = parseFloat((parseFloat(rboat.boat.BoatCharge) * Charges) / 100).toFixed(2);

          RescheduleAmount = (parseFloat(RescheduleAmount) + parseFloat(boatRescheduleAmount)).toFixed(2);
          console.log({ boatRescheduleAmount, Charges, RescheduleAmount, rboat });
        }
      }
    });
    let Percentage = parseFloat(100 + parseFloat(SGST) + parseFloat(CGST)).toFixed(2);
    let CGSTFinal = parseFloat(parseFloat(parseFloat(RescheduleAmount) / parseFloat(Percentage)) * CGST).toFixed(2);
    let SGSTFinal = parseFloat(parseFloat(RescheduleAmount / Percentage) * SGST).toFixed(2);
    RescheduleGST = parseFloat(parseFloat(CGSTFinal) + parseFloat(SGSTFinal)).toFixed(2);
    RescheduleNetAmount = parseFloat(parseFloat(RescheduleAmount)).toFixed(2);
    RescheduleAmount = parseFloat(parseFloat(RescheduleAmount) - parseFloat(RescheduleGST)).toFixed(2);
    // RescheduleGST = parseFloat((parseFloat(RescheduleAmount) * TotalGSTPercentage) / 100).toFixed(2);

    console.log({ Percentage, RescheduleAmount, CGSTFinal, SGSTFinal, RescheduleGST, RescheduleNetAmount });
    await this.setState({ RescheduleAmount: RescheduleAmount, RescheduleGST: RescheduleGST, RescheduleNetAmount: RescheduleNetAmount });
    this.forceUpdate();
  };
  onSubmit = async () => {
    await this.setState({ loading: true });
    let UserId = getLocalStorageValues("UserId");
    let Mobile = getLocalStorageValues("MobileNo");
    let Email = getLocalStorageValues("EmailId")!="" && getLocalStorageValues("EmailId")!=null && getLocalStorageValues("EmailId")!=undefined ? getLocalStorageValues("EmailId") : "";
    let BRSNewDate = [];
    let BRSBookingPin = [];
    let BRSTimeSlot = [];
    let BRSOtherServiceDate = this.formApi.getValue("BRSOtherServiceDate") ? this.formApi.getValue("BRSOtherServiceDate") : "";
    Object.values(this.state.selectedTime).map((rboat) => {
      if ((rboat.slotId && rboat.slotDate, rboat.boat)) {
        BRSNewDate.push(format(new Date(rboat.slotDate), "yyyy-MM-dd"));
        BRSTimeSlot.push(rboat.slotId);
        BRSBookingPin.push(rboat.boat.BookingPin);
      }
    });

    if (BRSTimeSlot.length > 0 && BRSNewDate.length > 0 && BRSBookingPin.length > 0) {
      if (this.state.AvailableOtherService.length > 0) {
        if (BRSOtherServiceDate === "") {
          return await this.setState({
            loading: false,
            variant: "info",
            openNotification: true,
            message: "Select Other Facilities Date",
          });
        }
      }
      let bookingData = {
        BRSBookingId: this.state.Rescheduleinfo.BookingId,
        BRSCharge: this.state.RescheduleAmount,
        BRSNewDate: BRSNewDate.join(","),
        BRSRuleId: this.state.RescheduleCharges.ActivityId,
        BRSCGST: this.state.GSTDetails.CGST,
        BRSSGST: this.state.GSTDetails.SGST,
        BRSBookingPIN: BRSBookingPin.join(","),
        BRSTimeSlot: BRSTimeSlot.join(","),
        BRSChargeType: this.state.RescheduleCharges.ChargeType,
        Amount: this.state.RescheduleNetAmount,
        BFDInitBoatCharge: "0",
        BFDInitNetAmount: "0",
        BalanceAmount: "0",
        BFDGST: "0",
        BoatDeposit: ["0"],
        BoatHouseId: this.state.Rescheduleinfo.BoatHouseId,
        BoatHouseName: this.state.Rescheduleinfo.BoatHouseName,
        BoatPremiumStatus: ["0"],
        BoatSeaterId: ["0"],
        BoatTypeId: ["0"],
        BookingBlockId: ["0"],
        BookingDate: format(new Date(), "dd/MM/yyyy"),
        BookingDuration: ["0"],
        BookingMedia: "PW",
        BookingPin: this.state.Rescheduleinfo.BookingPin,
        BookingTimeSlotId: ["0"],
        BookingType: "R",
        CGSTOthTaxAmount: ["0"],
        CGSTTaxAmount: ["0"],
        CollectedAmount: this.state.RescheduleNetAmount,
        EmailId: Email,
        EntryType: "PB",
        InitBoatCharge: ["0"],
        InitNetAmount: ["0"],
        InitOfferAmount: ["0"],
        InitRowerCharge: ["0"],
        MobileNo: Mobile,
        ModuleType: "Boating",
        NoOfChild: 0,
        NoOfInfant: 0,
        NoOfPass: 0,
        OthChargePerItem: ["0"],
        OthNetAmount: ["0"],
        OthNoOfItems: ["0"],
        OthServiceId: ["0"],
        OthServiceStatus: ["N"],
        PaymentMode: "Online",
        PremiumStatus: "0",
        SGSTOthTaxAmount: ["0"],
        SGSTTaxAmount: ["0"],
        UserId: UserId,
        BRSOthersRescheduleDate: BRSOtherServiceDate,
        currency:"INR",
        billing_name:"",
        billing_address:"",
        billing_city:"",
        billing_state:"",
        billing_zip:"",
        billing_country:"India",
        delivery_name:"",
        delivery_address:format(new Date(), "dd/MM/yyyy"),
        delivery_city:"R",
        delivery_state:"",
        delivery_zip:"",
        delivery_country:"India",
        delivery_tel:"",
        merchant_param1:this.state.Rescheduleinfo.BoatHouseId,
        merchant_param2:"",
        merchant_param3:getLocalStorageValues("UserId"),
        merchant_param4:this.state.Rescheduleinfo.BoatHouseName,
        merchant_param5:"BoatPaymentHandler.html"
      };
      console.log(bookingData, "bookingData");
      const res = await rescheduleBeforeTransaction(bookingData);
      if (res?.data?.StatusCode === 1 && res.data?.Response?.includes("Success")) {
        let bookingRes = res.data.Response;
        let bookingId = bookingRes.replace(/[^\d.-]/g, "");
        removeCookieData("Time");
        let paymentData = {
          "QueryType" : "GetPaymentGatewayPublic",
                         "ServiceType" : "",
                         "BoatHouseId" : "",
                         "Input1" : "",
                         "Input2" : "",
                         "Input3" :"",
                         "Input4" : "",
                         "Input5" : ""
      }
        const resPaymentData = await getDefaultPaymentType(paymentData);
        console.log("resPaymentData",resPaymentData)
        if(resPaymentData?.data?.Table?.[0]?.["PaymentGateway"]?.toLowerCase() !="hdfc" && Object.keys(resPaymentData?.data).length > 0){
          this.props.history.push({
            pathname: `${subDirectory}/boatPaymentPage`,
            state: {
              RescheduleData: { ...this.state },
              bookingData: bookingData,
              PaymentType: "Reschedule",
              TotalAmount: this.state.RescheduleNetAmount,
              BoatHouseId: this.state.Rescheduleinfo.BoatHouseId,
              BookingId: bookingId,
              BoatHouseName: this.state.Rescheduleinfo.BoatHouseName,
              TripDate: new Date(),
              BookingType: "R",
              shortName: this.state.Rescheduleinfo.BHShortCode,
              UserId: UserId,
              Mobile: Mobile,
              Email: Email,
            },
          });
        }else{
              // const randomNum = Math.floor(Math.random() * 100);
              // const paddedRandomNum = randomNum.toString().padStart(2, '0');
              // const orderId = this.state.Rescheduleinfo.BHShortCode + "-" + paddedRandomNum;
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = `${paymentGatwayURI.paymentGatwayURI}/ccavRequestHandler`;
              form.style.display = 'none'; // Hide the form
          
              // Add input fields
              const data1 = {
                  "merchant_id" : "3401574",
                  "order_id" : bookingId,
                  "currency": "INR",
                  "amount": this.state.RescheduleNetAmount,
                  "redirect_url":"https://ttdc.in/hdfc-payment-gateway/ccavResponseHandler",
                  "cancel_url":"https://ttdc.in/hdfc-payment-gateway/ccavResponseHandler",
                  "language":"EN",
                  "billing_name":"",
                  "billing_address":"",
                  "billing_city":"",
                  "billing_state":"",
                  "billing_zip":"",
                  "billing_country":"India",
                  "billing_tel":getLocalStorageValues("MobileNo"),
                  "billing_email":Email,  
                  "delivery_name":"",
                  "delivery_address":format(new Date(), "dd/MM/yyyy"),
                  "delivery_city":"R",
                  "delivery_state":"",
                  "delivery_zip":"",
                  "delivery_country":"India",
                  "delivery_tel":"",
                  "merchant_param1":this.state.Rescheduleinfo.BoatHouseId,
                  "merchant_param2":"",
                  "merchant_param3":getLocalStorageValues("UserId"),
                  "merchant_param4":this.state.Rescheduleinfo.BoatHouseName,
                  "merchant_param5":"BoatPaymentHandler.html",
                  "promo_code":"",
                  "customer_identifier":""
              };
          
              Object.keys(data1).forEach(key => {
                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = key;
                  // input.value = data1[key];
                  input.value = this.encryptedValuesFun(data1[key])
                  form.appendChild(input);
              });
          
              document.body.appendChild(form);
          
              // Submit the form
              form.submit();
          
        }
      } else {
        await this.setState({
          loading: false,
          variant: "info",
          openNotification: true,
          message: "Something went wrong try again",
        });
      }
    } else {
      await this.setState({
        loading: false,
        variant: "info",
        openNotification: true,
        message: "Select Reschedule Time",
      });
    }
    this.setState({ loading: false });
  };
  setFormApi = (formApi) => {
    this.formApi = formApi;
  };
  render() {
    const { RescheduleCharges } = this.state;
    console.log(this.state);

    return (
      <Fragment>
        <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <Loader fullPage loading={this.state.loading} />
        <Form
          getApi={this.setFormApi}
          // onSubmit={this.onSubmit}
        >
          {({ formApi, formState }) => (
            <div className="boatlistmainblock  reschedule-information">
              <NavBar {...this.props} />

              <div className="Boatrescheduleblock">
                <div className="boatschedulecardblock">
                  <div className="d-flex justify-content-between flex-wrap mt-3">
                    <div
                      className="d-flex align-items-center"
                      style={{ fontSize: "16px", color: "white", cursor: "pointer" }}
                      onClick={() => {
                        this.props.history.goBack();
                      }}
                    >
                      <BsArrowLeft className="mr-2" />
                      Back
                    </div>
                    {/* <div className="">
                <Link to={`${subDirectory}/RescheduleHistory`}>
                  <div className="headofreschedulehis">
                    Reschedule History <BsArrowRight className="ml-2" />
                  </div>
                </Link>
              </div> */}
                    <div className="d-flex justify-content-center">
                      <div className="headofreschedule">Reschedule Details</div>
                    </div>
                    <div></div>
                  </div>
                  {/* <div className="d-flex justify-content-center">
                    <div className="headofreschedule">Boat Reschedule</div>
                  </div> */}

                  <Row className="rsrow1 ml-2">
                    <Col md={12}>
                      <Row>
                        {true && (
                          <Col md={8}>
                            <Row>
                              <div className="reschedulecard">
                                <div className="reschedule-list w-100">
                                  <div className="reschedule-info-title mt-2">
                                    <div className="reschdule-info-boat ml-2">
                                      <div className="reschedule-boathouse-name">{this.state.Rescheduleinfo.BoatHouseName}</div>
                                      <div className="reschdule-info-name">{this.state.Rescheduleinfo.BookingDate?.split(" ")[0]}</div>
                                    </div>
                                    <div className="reschedule-info-booking mr-2">
                                      <div className="reschdule-info-name">Booking Id </div>
                                      {/* <div className="reschdule-info-name">Booking Pin : {this.state.Rescheduleinfo.BookingPin}</div> */}
                                      <div className="reschdule-info-name-content text-center">{this.state.Rescheduleinfo.BookingId}</div>
                                    </div>
                                  </div>
                                  {this.state.isReschedulingLoading === true && (
                                    <div className="w-100">
                                      <Skeleton loading={this.state.isReschedulingLoading} active />
                                      {/* <SkRescheduleDetailsCard /> */}
                                    </div>
                                  )}
                                  {this.state.isReschedulingLoading === false && (
                                    <div className="reschedule-table-container">
                                      <table class="table table-responsive reschedule-table">
                                        <thead>
                                          <tr>
                                            {/* <th>Booking Id</th> */}
                                            <th colSpan="2">Boat</th>
                                            <th>Pin</th>

                                            <th>Time</th>
                                            <th>Boat Charge</th>

                                            <th>Rescheduled Date</th>
                                            <th>Reschedule Date</th>
                                            <th>Reschedule Time</th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.AvailableRescheduleBoat?.map((boat, i) => {
                                            return boat.Alert.includes("Success") ? (
                                              <tr>
                                                <td colSpan="2">{boat.BoatTypeName + " " + boat.BoatSeaterName}</td>
                                                <td>{boat.BookingPin}</td>

                                                <td> {boat.SlotTime?.includes("-") ? boat.SlotTime?.split("-")[0] : boat.SlotTime}</td>
                                                <td> {boat.BoatCharge}</td>

                                                <td>{boat.RescheduledDate}</td>
                                                <td>
                                                  <div>
                                                    <DatePicker
                                                      dateFormat=" eee, dd/MM/yyyy"
                                                      // onClick={this.datePicker}
                                                      // field={`boatDate${boat.BoatReferenceNo}`}
                                                      selected={this.state.selectedDate?.[`${boat.BoatReferenceNo}`]}
                                                      onChange={(date) => {
                                                        this.handleBoatDateChange(date, boat);
                                                      }}
                                                      className="boatrdate"
                                                      placeholderText="Select"
                                                      // open={this.state.isDatePick}
                                                      minDate={new Date()}
                                                      disabledKeyboardNavigation
                                                    />
                                                  </div>
                                                </td>
                                                <td>
                                                  {
                                                    <DropDown
                                                      field={`boatTime${boat.BoatReferenceNo}`}
                                                      // label="Reason for Cancellation"
                                                      // faClass="fa fa-building"
                                                      className="form-control-sm "
                                                      optionsNames={{
                                                        value: "SlotId",
                                                        label: "SlotStartTime",
                                                      }}
                                                      options={this.state.AvailableTimeSlot?.[`${boat.BoatReferenceNo}`]}
                                                      onChange={(e) => this.handleBoatTimeChange(e, boat)}
                                                      initialValue={this.state.selectedTime?.[`${boat.BoatReferenceNo}`]?.slotId}
                                                    />
                                                  }
                                                </td>
                                              </tr>
                                            ) : (
                                              <tr>
                                                <td colSpan="8">{boat.Alert}</td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                  {this.state.AvailableOtherService.length > 0 && (
                                    <div className="other-reschedule-table-container">
                                      <div className="other-reschdule-list">
                                        <table class="table table-responsive reschedule-table-other">
                                          <thead>
                                            <tr>
                                              {/* <th>Booking Id</th> */}
                                              <th colSpan="2">Other Facilities</th>
                                              <th>No of Items</th>
                                              <th>Total Charge</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {this.state.AvailableOtherService?.map((service, i) => {
                                              return (
                                                <tr>
                                                  <td colSpan="2">{service.ServiceName}</td>
                                                  <td> {service.NoOfItems}</td>
                                                  <td>{service.NetAmount}</td>
                                                </tr>
                                              );
                                            })}
                                            {/* <tr>
                                            <td colSpan="2">Rescheduled date</td>
                                            <td colSpan="2">{this.state.AvailableOtherService?.[0]?.RescheduledDate}</td>
                                          </tr>
                                          <tr>
                                            <td colSpan="2">Reschedule date</td>
                                            <td colSpan="2">
                                              <DropDown
                                                field={`BRSOtherServiceDate`}
                                                className="form-control-sm "
                                                optionsNames={{
                                                  value: "ROSDate",
                                                  label: "ROSDate",
                                                }}
                                                options={Object.values(this.state.AvailableOtherServiceDate)}
                                                onChange={(e) => this.handleOtherServiceDateChange(e)}
                                                // initialValue={this.state.selectedTime?.[`${boat.BoatReferenceNo}`]?.slotId}
                                              />
                                            </td>
                                          </tr> */}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="other-reschedule-date-container ml-2">
                                        <div className="other-reschedule-date-list">
                                          <div className="text-center other-facility">Other Facilities </div>
                                          {this.state.AvailableOtherService?.[0]?.RescheduledDate && (
                                            <div className="other-rescheduling-date">
                                              <div className="other-title">Rescheduled date</div>
                                              <div className="other-data">{this.state.AvailableOtherService?.[0]?.RescheduledDate}</div>
                                            </div>
                                          )}
                                          <div className="other-rescheduling-selected-date">
                                            <div className="other-title">Reschedule date</div>
                                            <div className="other-selected-date">
                                              <DropDown
                                                field={`BRSOtherServiceDate`}
                                                className="form-control-sm "
                                                optionsNames={{
                                                  value: "ROSDate",
                                                  label: "ROSDate",
                                                }}
                                                options={Object.values(this.state.AvailableOtherServiceDate)}
                                                onChange={(e) => this.handleOtherServiceDateChange(e)}
                                                // initialValue={this.state.selectedTime?.[`${boat.BoatReferenceNo}`]?.slotId}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Row>
                          </Col>
                        )}

                        {
                          <Col md={4}>
                            <div className="summaryblockmain ml-3">
                              <>
                                <div className="percentblock">
                                  <span>Rescheduling Charge</span>&nbsp;
                                  {RescheduleCharges.ChargeType === "P" && (
                                    <div>
                                      {RescheduleCharges.Charges}%<sub>/Boat</sub>
                                    </div>
                                  )}
                                  {RescheduleCharges.ChargeType === "F" && (
                                    <div>
                                      ₹&nbsp;{RescheduleCharges.Charges}
                                      <sub>/Boat</sub>
                                    </div>
                                  )}
                                </div>
                                <div className="listvalueblock mt-2">
                                  <div className="overallistblock">
                                    <div className="overallmainhead">
                                      <table className="table reschedule-charge-table">
                                        <tbody>
                                          <tr>
                                            <th className="boatname boatth"> Reschedule Charges</th>

                                            <td align="end" className="boatname boattd">
                                              <div className="boatcost">
                                                {" "}
                                                <span className="boatcostsubtotal">₹ {parseFloat(this.state.RescheduleAmount).toFixed(2)}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="boatname boatth"> GST</th>

                                            <td align="end" className="boatname boattd">
                                              <div className="boatcost">
                                                <span className="boatcostsubtotal">₹ {parseFloat(this.state.RescheduleGST).toFixed(2)}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="boatname boatth"> Total Amount</th>

                                            <td align="end" className="boatname boattd">
                                              <div className="boatcost">
                                                <span className="boatcostsubtotal reschedulefinal-amount">₹ {parseFloat(this.state.RescheduleNetAmount).toFixed(2)}</span>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <div className="text-center">
                                  <button onClick={this.onSubmit} className="btn btn-success paynowbtn">
                                    Pay Now
                                  </button>
                                </div>{" "}
                              </>
                            </div>
                          </Col>
                        }
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          )}
        </Form>
      </Fragment>
    );
  }
}

export default RescheduleInfo;
